module.exports = __webpack_public_path__ + "static/media/google-play-badge.90c8cdd0.svg";